module.exports = __webpack_public_path__ + "static/media/mail_primary.cbc83075.svg";